module.exports = __webpack_public_path__ + "static/media/right_arrow_white.89bd15b3.svg";